// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wD50","title":"styles_title__3DV57"};